module.exports = __webpack_public_path__ + "static/media/xiaoshouzhichikeyewuliucheng.b9d12058.png";